const DocumentsIcons = {
  doc: 'doc',
  docx: 'docx',
  txt: 'txt',
  dwg: 'dwg',
  pdf: 'pdf',
  xls: 'xls',
  xlsx: 'xlsx',
  default: 'doc',
};

export default DocumentsIcons;
